export const selectedCountry = {
  placeholder: "Select a country",
};
